import { BASE_PATH_API } from 'constants/env'
import { useState } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'

const useAddProductStore = () =>{
    const Domain = BASE_PATH_API
    const [responseProductStore, setResponseProducts] = useState(null)
    const [responseErrorStore, setResponseError] = useState(null)
    const [giftTable , dispatch ] = useStore((state) => state.giftTable.giftTable)
    
    const getProduct = async (sku) => {
        dispatch(showLoader());
        setResponseProducts(null)
        setResponseError(null)

        const payload = {
            gifts: [
                {
                    sku: String(sku),
                    quantity: 1
                }
            ]
        }

        const header = {
            method: 'PATCH',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        try{
            const response = await fetch(`${Domain}/gift-table/v1/gift-table/${giftTable?.evento}/only-store`, header)
            const data = await response.json()
            if(data?.data){
                setResponseProducts(data?.data)
            }else{
                dispatch(hideLoader());
                setResponseError({
                    statusCode: data?.metadata?.http_status
                })
                dispatch(hideLoader());
            }
        } catch (error) {
            dispatch(hideLoader());
            console.error('Error fetching productsFilter data:', error);
        }
    }

    const handleStoreSKU = (sku) => {
        getProduct(sku)
    }
    const setResetResponseStore = () => {
        setResponseProducts(null)
        setResponseError(null)
    }

    return {
        handleStoreSKU,
        setResetResponseStore,
        responseProductStore,
        responseErrorStore
    }
}

export default useAddProductStore